'use strict';

export function appConfig($urlRouterProvider, $locationProvider, $authProvider, $mdThemingProvider, $httpProvider, $qProvider, $urlServiceProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true).hashPrefix('');

  $authProvider.configure([
    {
      default: {}
    },
    {
      oemUser: {
        tokenValidationPath: '/oem_auth/validate_token',
        signOutUrl: '/oem_auth/sign_out',
        emailSignInPath: '/oem_auth/sign_in'
      }
    }
  ]);

  // 背景が薄いグレーになる angular-material の仕様変更への対応
  const backgroundMap = $mdThemingProvider.extendPalette('grey', {
    '50': '#ffffff'
  });
  $mdThemingProvider.definePalette('backgroundTheme', backgroundMap);

  $mdThemingProvider.theme('default')
    .backgroundPalette('backgroundTheme');

  $mdThemingProvider.theme('oemTheme')
    .primaryPalette('teal')
    .warnPalette('orange');

  $qProvider.errorOnUnhandledRejections(false);
}



// WEBPACK FOOTER //
// ./public/dev/app/app.config.js